export const RouteNames = {
  Billing: "Billing",
  BillDetail: "BillDetail",
  Connect: "Connect",
  ChoosePlan: "ChoosePlan",
  CompanyProfile: "CompanyProfile",
  ContentMenu: "ContentMenu",
  CreateAccount: "CreateAccount",
  Customer: "Customer",
  CustomerList: "CustomerList",
  Dashboard: "Dashboard",
  Error: "Error",
  FeedConfig: "FeedConfig",
  FeedList: "FeedList",
  FeedModeration: "FeedModeration",
  FeedModerationOptions: "FeedModerationOptions",
  HandleSaveOnAuth: "HandleSaveOnAuth",
  IFrameAuthError: "IFrameAuthError",
  IFrameGeneralError: "IFrameGeneralError",
  IntegrationsList: "IntegrationsList",
  Keywords: "Keywords",
  LgSuperSign: "LgSuperSign",
  Package: "Package",
  Payment: "Payment",
  ProviderAuthSidedoor: "ProviderAuthSidedoor",
  SamsungVxtLogin: "SamsungVxtLogin",
  Settings: "Settings",
  SignIn: "Signin",
  SignInOidc: "SigninOidc",
  SignInOta: "SignInOta",
  SignOut: "Signout",
  Subscribe: "Subscribe",
  ThirdPartyOauth: "ThirdPartyOauth",
  UserDetail: "UserDetail",
  UserList: "UserList",
  ValidateEmail: "ValidateEmail",
  WhiteLabel: "WhiteLabel",
} as const;

export type RouteContext = "customer" | "reseller";
export const ResellerRouteType = "Reseller";
export const FeedRouteType = "Feeds";
export const PackageRouteType = "Package";

export function feedRouteContext(name: string): string {
  return `${FeedRouteType}-${name}`;
}

export function packageRouteContext(name: string): string {
  return `${PackageRouteType}-${name}`;
}

export function resellerRouteContext(name: string): string {
  return `${ResellerRouteType}-${name}`;
}
